import qs from 'query-string';
import { ALEF_USER_KEY } from './constants';

export const getQueryParams = history =>
  qs.parse(history.location.search.split('?')[1]);

export const getAuthData = () => {
  const user = localStorage.getItem(ALEF_USER_KEY);

  return user && JSON.parse(user);
};

export const studentSubmissionPageUrl = ({
  assignmentInstanceId,
  assignmentId,
  mloId,
  classId,
  studentId,
  contentId,
  academicYearId,
  returnUrl,
  isGradableItemsLockedByDefault,
}) => {
  const qsParams = qs.stringify({
    classId,
    mloId,
    contentId,
    academicYearId,
    isGradableItemsLockedByDefault,
  });

  if (assignmentInstanceId)
    return `/assignmentInstance/${assignmentInstanceId}/evaluate/${studentId}?${qsParams}&returnUrl=${returnUrl}`;

  return `/assignment/${assignmentId}/evaluate/${studentId}?${qsParams}&returnUrl=${returnUrl}`;
};

export const classDashboardPageUrl = ({
  assignmentInstanceId,
  assignmentId,
  mloId,
  classId,
  academicYearId,
  isGradableItemsLockedByDefault,
  returnUrl,
}) => {
  const qsParams = qs.stringify({
    classId,
    mloId,
    academicYearId,
    isGradableItemsLockedByDefault,
  });

  if (assignmentInstanceId)
    return `/assignmentInstance/${assignmentInstanceId}/classDashboard?${qsParams}&returnUrl=${returnUrl}`;

  return `/assignment/${assignmentId}/classDashboard?${qsParams}&returnUrl=${returnUrl}`;
};

export const getReturnUrlAndRestOfQueryParams = () => {
  const returnUrl =
    window.location.hash &&
    window.location.hash.split('returnUrl=')[1] &&
    window.location.hash.split('returnUrl=')[1].split('&')[0];

  return returnUrl || '';
};
